/* eslint-env browser, jquery */
/* global Modernizr, TweenMax, TimelineLite */
import domify from 'domify';
import page from 'modules/ab-page-js';
import container from 'modules/section-content';
import rg from 'modules/npm-component/require-global';
import Batch from 'batch';
import changelogPage from './changelog-page.pug';
import appliancePage from './appliance-page.pug';
import oldReleasesPage from './oldreleases-page.pug';
import metadata from './metadata.json';
import { changelogData, changelogApplianceData, changelogOldData } from './data';

export default function register() {
  page('/changelog', renderChangelog, loadScripts, snippets);
  page('/changelog/appliance', renderAppliance, loadScripts, snippets);
  page('/changelog/appliance/old', renderOldReleases, loadScripts, snippets);
}

function render(html, ctx, next) {
  const renderOptions = {
    metadata,
    // Only pass view on client render.
    ...(ctx.init ? {} : { view: domify(html) })
  };
  container.render(renderOptions);
  next();
}

function renderChangelog(ctx, next) {
  render(changelogPage({ ...changelogData }), ctx, next);
}

function renderAppliance(ctx, next) {
  render(appliancePage({ ...changelogApplianceData }), ctx, next);
}

function renderOldReleases(ctx, next) {
  render(oldReleasesPage({ ...changelogOldData }), ctx, next);
}

function loadScripts(ctx, next) {
  const batch = new Batch();

  batch.push(done => {
    rg('https://cdnjs.cloudflare.com/ajax/libs/gsap/1.15.1/TweenMax.min.js', 'TweenMax', () => {
      rg(
        'https://cdnjs.cloudflare.com/ajax/libs/SuperScrollorama/1.0.3/jquery.superscrollorama.min.js',
        '$.superscrollorama',
        done
      );
    });
  });

  batch.push(done => {
    rg('//ajax.aspnetcdn.com/ajax/modernizr/modernizr-2.8.3.js', 'Modernizr', done);
  });

  batch.end(next);
}

function snippets(ctx, next) {
  $('a[data-control="release"]').click(function scrollToRelease() {
    // prevent the default action for the click event
    event.preventDefault();

    // get the full url - like mysitecom/index.htm#home
    const fullUrl = this.href;

    // split the url by # and get the anchor target name - home in mysitecom/index.htm#home
    const parts = fullUrl.split('#');
    const trgt = parts[1];

    // get the top offset of the target anchor
    const targetOffset = $(`[name="${trgt}"]`).offset();
    const targetTop = targetOffset.top;

    // goto that anchor by setting the body scroll top to anchor top
    $('html, body').animate({ scrollTop: targetTop }, 500);
  });

  if (!Modernizr.touch) {
    const controller = $.superscrollorama({
      triggerAtCenter: false,
      playoutAnimations: true
    });

    controller.pin($('#pin'), 16000, {
      anim: new TimelineLite()
        .append(
          TweenMax.fromTo(
            $('#card1'),
            5,
            { css: { opacity: 1, left: '50%' }, immediateRender: true },
            { css: { opacity: 0, left: '200%' } }
          )
        )
        .append(
          TweenMax.fromTo(
            $('#card2'),
            3,
            { css: { opacity: 0, left: '200%' }, immediateRender: true },
            { css: { opacity: 1, left: '50%' } }
          )
        )
        .append(
          TweenMax.fromTo(
            $('#card2'),
            5,
            { css: { left: '50%' }, immediateRender: true },
            { css: { opacity: 0, left: '200%' } }
          )
        )
        .append(
          TweenMax.fromTo(
            $('#card3'),
            3,
            { css: { opacity: 0, left: '200%' }, immediateRender: true },
            { css: { opacity: 1, left: '50%' } }
          )
        )
    });
  }

  next();
}



// WEBPACK FOOTER //
// ./src/pages/changelog/changelog.js